import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography
} from '@mui/material';
import React, { useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  CalculateOrgProfilePercentage,
  CalculateUserProfilePercentage
} from '../helper/commonHelper';

export default function ProfileCompletionBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openWarningModal, setOpenWarningModal] = useState(false);
  const currentUser = useSelector((state) => state.auth.currentUser);
  const selectedOrg = useSelector((state) => state.org.selectedOrg);

  const userCompletedProfile = useMemo(
    () => CalculateUserProfilePercentage(currentUser),
    [currentUser]
  );

  const orgCompletedProfile = useMemo(() => {
    if (currentUser?.profile === 'admin' || currentUser?.profile === 'teacher') {
      return CalculateOrgProfilePercentage(selectedOrg);
    }
    return 0;
  }, [selectedOrg]);

  useEffect(() => {
    if (location.pathname.includes('/dashboard/app')) {
      if (currentUser?.profile === 'student' && userCompletedProfile !== 100) {
        setOpenWarningModal(true);
      } else if (userCompletedProfile !== 100 && orgCompletedProfile !== 100) {
        setOpenWarningModal(true);
      }
    }
  }, []);

  const handleProfileOpen = () => {
    if (currentUser?.profile === 'student') {
      navigate(`/dashboard/account`, {
        state: {
          openModal: true
        },
        replace: true
      });
    } else if (userCompletedProfile !== 100) {
      navigate(`/dashboard/account`, {
        state: {
          openModal: true
        },
        replace: true
      });
    } else {
      navigate(`/dashboard/institute`, {
        state: {
          openModal: true
        },
        replace: true
      });
    }
  };

  if (currentUser?.profile === 'student' && userCompletedProfile === 100) {
    return null;
  }
  if (userCompletedProfile === 100 && orgCompletedProfile === 100) {
    return null;
  }
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ width: '100%', mr: 1 }}>
          <LinearProgress
            variant="determinate"
            value={
              orgCompletedProfile
                ? (orgCompletedProfile + userCompletedProfile) / 2
                : userCompletedProfile
            }
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">
            {`${Math.round(
              orgCompletedProfile
                ? (orgCompletedProfile + userCompletedProfile) / 2
                : userCompletedProfile
            )}%`}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="caption"
        color="text.secondary"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          handleProfileOpen();
        }}
        sx={{
          '&:hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
            color: 'blue'
          }
        }}
      >
        Complete your profile
      </Typography>
      {openWarningModal && (
        <Dialog onClose={() => setOpenWarningModal(false)} open={openWarningModal}>
          <DialogTitle>Complete Profile</DialogTitle>
          <DialogContent>
            You're profile is pending complete your profile and take rewards
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenWarningModal(false)}>Later</Button>
            <Button
              variant="contained"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleProfileOpen();
                setOpenWarningModal(false);
              }}
            >
              Complete Now
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
